import React, { useState } from 'react';
import { Field } from 'formik';
import FormInput from 'shared/Inputs/FormInput';
import { postcodeMask, telephoneMask } from 'shared/Inputs/inputMasks';
import { formatText } from 'utils/text';
import { fetchAddresses, formatAddressLabel } from 'utils/address';
import { AddressType } from 'components/Forms/Address/types';
import { isNotEmptyString } from 'utils/form/formUtils';

const ClubDetails: React.FC<any> = ({ setFieldValue }: any) => {
  const [relatedAddresses, setRelatedAddresses] = useState<AddressType[]>([]);

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    fetchAddresses(e.target.value).then((relatedAddresses: AddressType[]) => {
      setRelatedAddresses(relatedAddresses);
    });
  };

  const selectAddressHandler = (address: AddressType) => {
    return () => {
      setFieldValue('houseNumber', [address.flatNumber, address.buildingName].filter(isNotEmptyString).join(' '));
      setFieldValue('addressLine1', [address.buildingNumber, address.street].filter(isNotEmptyString).join(' '));

      setFieldValue('city', address.city);
      setFieldValue('county', address.county);
      setFieldValue('postcode', address.postcode);
    };
  };

  return (
    <>
      <div className="form__header">
        <h2 className="plum no-margin">Club Details</h2>
      </div>
      <Field
        name="clubName"
        component={FormInput}
        label="Name of Club"
        inputWidth={7}
        iconWidth={5}
        showBorder={false}
      />

      <Field
        name="postcode"
        component={FormInput}
        label="Post Code"
        inputWidth={7}
        iconWidth={5}
        showBorder={false}
        mask={postcodeMask}
        transformValue={(v: string) =>
          formatText(v)
            .toUpperCase()
            .getText()
        }
        handleBlur={handleBlur}
      />

      {relatedAddresses && relatedAddresses.length > 0 && (
        <div className="form-control">
          <select className="full-address__address-picker form__input" multiple={true}>
            {relatedAddresses.map((address: AddressType, index: number) => (
              <option key={`postcode-related-addresses-${index}`} onClick={selectAddressHandler(address)}>
                {formatAddressLabel(address)}
              </option>
            ))}
          </select>
        </div>
      )}

      <Field
        name="houseNumber"
        component={FormInput}
        label="Address Line 1"
        inputWidth={7}
        iconWidth={5}
        showBorder={false}
      />

      <Field
        name="addressLine1"
        component={FormInput}
        label="Address Line 2"
        inputWidth={7}
        iconWidth={5}
        showBorder={false}
      />

      <Field
        name="addressLine2"
        component={FormInput}
        label="Address Line 3"
        inputWidth={7}
        iconWidth={5}
        showBorder={false}
      />

      <Field name="city" component={FormInput} label="Town/City" inputWidth={7} iconWidth={5} showBorder={false} />

      <Field name="county" component={FormInput} label="County" inputWidth={7} iconWidth={5} showBorder={false} />

      <Field
        name="email"
        component={FormInput}
        label="Email Address"
        inputWidth={7}
        iconWidth={5}
        showBorder={false}
        type="email"
      />

      <Field
        name="telephoneNumber"
        component={FormInput}
        label="Telephone Number"
        inputWidth={7}
        iconWidth={5}
        showBorder={false}
        mask={telephoneMask}
        showMask={true}
      />
    </>
  );
};

export default ClubDetails;
